export function round2dec(v, precision = 3) {
    if (v) {
        const mult = Math.pow(10, precision);
        return Math.round(v * mult) / mult;
    }
    else {
        return v;
    }
}
export function airspeedMetersPerSecond(airspeedKmh) {
    return airspeedKmh / 3.6;
}
export class EnvironmentData {
    constructor(airDensity, gravity) {
        this.airDensity = airDensity;
        this.gravity = gravity;
        // "10C": 1.4207E-5,
        this.kinematicViscosity = 1.4207E-5; // FIXME: add configurable temperature and kinematic viscosity
    }
    dynamicPressure(airspeedKmh) {
        const airspeedMetersPerSecond_ = airspeedMetersPerSecond(airspeedKmh);
        return 0.5 * this.airDensity * airspeedMetersPerSecond_ * airspeedMetersPerSecond_;
    }
    reynoldsNumber(airspeedKmh, chordLengthMeters, kinematicViscosity) {
        // https://en.wikipedia.org/wiki/Reynolds_number
        // ρ is the density of the fluid (SI units: kg/m3)
        // u is the flow speed (m/s)
        // L is a characteristic length (m)
        // ν is the kinematic viscosity of the fluid (m2/s).
        // if using kinematic viscosity:
        // Reynolds = velocity * L / kinematic_viscocity
        const airspeedMetersPerSecond_ = airspeedMetersPerSecond(airspeedKmh);
        return airspeedMetersPerSecond_ * chordLengthMeters / kinematicViscosity;
    }
}
